import React, { useContext, useState } from "react";
import { BudgetContext } from "../../context/budget.context";
import { v4 as uuiv4 } from "uuid";
import { exampleService } from "../../services/example.service";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default function AddExpenseForm() {
  const { dispatch } = useContext(BudgetContext);
  const [item, setItem] = useState("");
  const [price, setPrice] = useState("");
  const { t } = useTranslation();

  function HandleChangedName(event) {
    setItem(event.target.value);
  }
  function HandleChangedCost(event) {
    setPrice(event.target.value);
  }

  async function HandleSubmitForm(event) {
    event.preventDefault();
    const expense = {
      id: uuiv4(),
      item: item,
      price: parseInt(price),
    };

    dispatch({
      type: "ADD_EXPENSE",
      payload: expense,
    });

    await exampleService.addExpenses({
      item,
      price,
    });
    setItem("");
    setPrice("");
  }

  return (
    <form onSubmit={HandleSubmitForm}>
      <div className="row">
        <div className="col-sm">
          <label htmlFor="item">{t("nameitem")}</label>
          <input
            required="required"
            type="text"
            className="form-control"
            id="item"
            value={item}
            onChange={HandleChangedName}
          ></input>
        </div>
        <div>
          <label htmlFor="price">{t("cost")}</label>
          <input
            required="required"
            type="number"
            className="form-control"
            id="price"
            value={price}
            onChange={HandleChangedCost}
          ></input>
        </div>
        <div>
          <button type="submit" className="btn btn-primary">
            {t("add")}
          </button>
        </div>
      </div>
    </form>
  );
}
